<template>
  <div :class="{ 'payment-container': !embedded }">
    <div :class="{ 'payment-card': !embedded }">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" class="payment-form" label-width="120px">
        <el-form-item label="代理商：" prop="userId">

          <el-select v-model="ruleForm.userId" placeholder="请选择代理商" filterable clearable class="form-control" @change="handleAgentChange" style="width:100%">
            <el-option
              v-for="item in agentData"
              :key="item.userId"
              :label="item.company"
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="balance-group" v-if="showBalance">
          <label class="form-label"></label>
          <span class="form-value text-red font-bold">账户余额：{{ accountBalance }} 元</span>
        </el-form-item>
        
        <el-form-item label="充值金额：" prop="money"  style="margin-bottom: 6px">
          <el-input 
            type="number"
            v-model="ruleForm.money" 
            placeholder="请输入充值金额" 
            class="form-control"
            @blur="focus()"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <label class="form-label"></label>
          <el-form-item class="amount-input-group">
            <!-- 快捷金额选择按钮组 -->
            <div class="amount-options">
              <span v-for="amount in [100, 200, 300, 500, 1000, 2000 ,5000 ,10000 ]" 
                    :key="amount" 
                    class="amount-option"
                    :class="{'active': ruleForm.money === amount.toString()}"
                    @click="setAmount(amount)">
                {{ amount }}
              </span>
            </div>
          </el-form-item>
        </el-form-item>
        <el-form-item label="大写金额：">
          <el-input  
            placeholder="大写金额" 
            class="form-control"
            v-model="amountInWords" 
            :disabled="true"
          ></el-input>
        </el-form-item>
        
        <el-form-item prop="password" label="密码：">
          <el-input  
            placeholder="请输入密码" 
            class="form-control"
            v-model="ruleForm.password" 
            show-password
            autocomplete="new-password"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="备注：">
          <el-input  
            placeholder="请输入备注内容" 
            class="form-control"
            v-model="ruleForm.remark"
          ></el-input>
        </el-form-item>
        
        <div class="action-buttons">
          <el-button type="primary" size="medium" @click="submitForm" class="pay-button">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { agentList } from "@/api/api.js"; //获取代理商的数据
import { agentUserAsset , recharge } from "@/api/api.js";//系统充值
export default {
  name:'systemPay',
  props: {
    // 是否嵌入弹窗模式：true 时去掉外层页面容器，成功后 emit('success') 而非通知
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ruleForm:{
        userId:undefined,
        money:'',
        password:'',
        remark:'',
      },
      amountInWords:'',
      accountBalance:0,
      showBalance: false,
      agentData: [],
      rules: {
        userId:[
          { required: true, message: "请选择代理商", trigger: "blur" }
        ],
        money:[
          { required: true, message: "请输入充值金额", trigger: "blur" }
        ],
        password:[
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
      }
    };
  },
  computed: {},
  methods: {
    // 获取初始化代理商列表
    selectAgentList(){
      agentList().then(res => {
        if (res.data.code == 200) {
          this.agentData = res.data.data;
          this.agentData.map(item =>{
            item.company = '【' + item.id + '-' + item.username + '】' + item.company
          })
        }
      })
    },
    // 焦点时触发大写金额
    focus(){
      this.amountInWords = this.convertCurrency(this.ruleForm.money)
    },
    // 转换大写的
    convertCurrency(money) {
      //汉字的数字
      var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
      //基本单位
      var cnIntRadice = new Array('', '拾', '佰', '仟');
      //对应整数部分扩展单位
      var cnIntUnits = new Array('', '万', '亿', '兆');
      //对应小数部分单位
      var cnDecUnits = new Array('角', '分', '毫', '厘');
      //整数金额时后面跟的字符
      var cnInteger = '整';
      //整型完以后的单位
      var cnIntLast = '元';
      //最大处理的数字
      var maxNum = 999999999999999.9999;
      //金额整数部分
      var integerNum;
      //金额小数部分
      var decimalNum;
      //输出的中文金额字符串
      var chineseStr = '';
      //分离金额后用的数组，预定义
      var parts;
      if (money == '') { return ''; }
      money = parseFloat(money);
      if (money >= maxNum) {
        //超出最大处理数字
        return '';
      }
      if (money == 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
      }
      //转换为字符串
      money = money.toString();
      if (money.indexOf('.') == -1) {
        integerNum = money;
        decimalNum = '';
      } else {
        parts = money.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
      }
      //获取整型部分转换
      if (parseInt(integerNum, 10) > 0) {
        var zeroCount = 0;
        var IntLen = integerNum.length;
        for (var i = 0; i < IntLen; i++) {
          var n = integerNum.substr(i, 1);
          var p = IntLen - i - 1;
          var q = p / 4;
          var m = p % 4;
          if (n == '0') {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0];
            }
            //归零
            zeroCount = 0;
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m == 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q];
          }
        }
        chineseStr += cnIntLast;
      }
      //小数部分
      if (decimalNum != '') {
        var decLen = decimalNum.length;
        for (var i = 0; i < decLen; i++) {
          var n = decimalNum.substr(i, 1);
          if (n != '0') {
            chineseStr += cnNums[Number(n)] + cnDecUnits[i];
          }
        }
      }
      if (chineseStr == '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (decimalNum == '') {
        chineseStr += cnInteger;
      }
      return chineseStr;
    },
    // 提交数据
    submitForm(){
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          recharge(this.ruleForm).then(res => {
            if (res.data.code == 200) {
              if (this.embedded) {
                // 嵌入弹窗模式：emit 出去由父组件关闭弹窗 & 刷新
                this.$emit('success');
              } else {
                this.$notify({
                  title: "成功",
                  message: "系统充值成功",
                  type: "success",
                  offset:30
                });
              }
              this.ruleForm = {userId:undefined,money:'',password:'',remark:''};
              this.amountInWords = '',
              this.accountBalance = 0;
              this.showBalance = false;
              this.$refs['ruleForm'].resetFields();
            }else{
              this.$message.error(res.data.message);
            }
          })
        }
      })
      
    },
    setAmount(amount) {
      this.ruleForm.money = amount.toString();
      this.amountInWords = this.convertCurrency(this.ruleForm.money)
    },
    //查询代理商余额
    handleAgentChange(userId) {
      if(!userId){
        this.showBalance = false;
        this.accountBalance = 0;
        return;
      }
      agentUserAsset({ userId }).then(res => {
        this.accountBalance = res.data.data.availAmount; 
        this.showBalance = true;
      }).catch(() => {
        this.$message.error("查询账户余额失败");
        this.showBalance = false;
      });
    },

  },
  mounted() {

  },
  created() {
    this.selectAgentList()
  }
};

</script>

<style scoped lang="less">
.payment-container {
  background-color: #f5f7fa;
  padding: 40px 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
}

.payment-card {
  width: 750px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  padding: 30px;
}

.payment-form {
  width: 100%;
}

.balance-group {
  margin-top: -10px;
}

.form-value {
  flex: 1;
  max-width: 450px;
  line-height: 20px; /* 与输入框高度对齐 */
}

.font-bold {
  font-weight: bold;
  font-size: 15px;
}

.text-red {
  color: #ff4d4f;
}

.form-control {
  flex: 1;
  max-width: 450px;
  transition: all 0.3s ease;

  &:focus {
    box-shadow: 0 0 0 2px rgba(144, 147, 153, 0.2);
  }

  // 隐藏数字输入框尾部的原生上下箭头（spinner）
  /deep/ input[type='number'] {
    -moz-appearance: textfield;
    appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}

.amount-input-group {
  flex: 1;
  max-width: 450px;
}

// 快捷金额选择样式
.amount-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  width: 100%; 
}

.amount-option {
  padding: 12px 0; 
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  flex: 1 0 calc(25% - 10px); // 三等分布局，减去间距
  text-align: center; 
  
  &:hover {
    border-color: #c0c4cc;
    background-color: #f5f7fa;
  }
  
  &.active {
    border-color: #409eff;
    background-color: #f0f7ff;
    color: #409eff;
    font-weight: 500;
  }
}

.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pay-button {
  width: 200px;
  height: 44px;
  font-size: 16px;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
}
</style>

